module.exports = __webpack_public_path__ + "img/home-img-02.ef8142f8.png";